await themeComponent(theme.components['mc-shopify'], false);

class McElement extends HTMLElement {
    version = '2.1.8'
    constructor(){
        super();
        this.addEventListener(MCEVENTS.RESET, this.reset);
    }
    activate = () => {
        this.classList.add('mc-active');
        this.dispatchEvent(new CustomEvent('mc-element:opened', { bubbles: true }));
        McShopify.customEvent(MCEVENTS.EL_ACTIVATED, null, this);
        this.afterOpen();
    }
    deactivate = () => {
        this.classList.remove('mc-active');
        this.dispatchEvent(new CustomEvent('mc-element:closed', { bubbles: true }));
        McShopify.customEvent(MCEVENTS.EL_ACTIVATED, null, this);
        this.afterClose();
    }

    toggle = () => {
        this.isActive() ? this.deactivate() : this.activate();
    }

    isActive = () => {
        return this.classList.contains('mc-active');
    }
    
    reload = (doc) => {
        const newContent = doc.querySelector(`#${this.id}`);
        this.innerHTML = newContent.innerHTML;
        this.afterReload();
    }
    
    registerReference = (reference) => {
        if(!this.references){
            this.references = new Array();
        }
        this.references.push(reference);
    }

     // Restituisce un selettore CSS univoco per questo elemento (id, classi e attributi)
    getSelector = () => {
        if (this.id) return `#${this.id}`;
        if (this.classList.length) return Array.from(this.classList).map(c => `.${c}`).join('');
        return this.tagName.toLowerCase();
        };

    reset = () => { this.deactivate(); }

    afterOpen = () => {}
    afterClose = () => {}
    afterReload = () => {}

    
}

window.McElement = McElement;